import type { AnchorHTMLAttributes } from 'react';
import clsx from 'clsx';

type Variante = 'primario' | 'fantasma';

type BotaoProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  variante?: Variante;
};

/**
 * CTA em formato de link (âncora de seção ou URL externa da SPA), nunca
 * `<button>`: toda ação deste componente é navegação. Cores só de token
 * `--color-auth-*`.
 */
export function Botao({
  variante = 'primario',
  className,
  children,
  ...resto
}: BotaoProps) {
  return (
    <a
      className={clsx(
        'rounded-auth-controle inline-flex items-center justify-center px-6 py-3 text-sm font-medium tracking-tight transition-colors duration-150',
        variante === 'primario' &&
          'bg-auth-marca-forte text-auth-marca-contraste hover:bg-auth-marca-forte-hover',
        variante === 'fantasma' &&
          'border-auth-borda/15 text-auth-texto hover:border-auth-borda/30 hover:bg-auth-superficie/[0.04] border',
        className,
      )}
      {...resto}
    >
      {children}
    </a>
  );
}
